import { api } from '@/lib/api'
import type { AuditLog } from '@/types/audit_log.types'

export const auditLogService = {
  async listLogs(
    companyId: string,
    tableName?: string,
    entityId?: string,
    limit: number = 100
  ): Promise<AuditLog[]> {
    let url = `/companies/${companyId}/audit-logs?limit=${limit}`
    if (tableName) url += `&table=${tableName}`
    if (entityId) url += `&entity=${entityId}`
    return api.get<AuditLog[]>(url)
  }
}
